/**
 * Browser↔server clock reconciliation for call timing.
 *
 * Call timestamps (`answeredAt`) are stamped with the API server's clock, but
 * elapsed time is measured in the browser. Subtracting one from the other
 * leaks any skew between the two machines straight into the UI: a browser
 * running 84s fast displayed `01:24` the instant a call connected, and one
 * running slow pinned the timer at `00:00` for a while.
 *
 * Every voice websocket envelope already carries the server's clock in
 * `eventAt`, so the offset is measured from traffic we receive anyway — no
 * extra request, no backend change. Network latency makes this accurate to
 * roughly one round trip, which is far below the 1s tick the timer renders.
 */

let offsetMs = 0;

/**
 * Record the server's clock from an envelope's `eventAt`. Unparseable or
 * missing input is ignored so a malformed event cannot corrupt the offset.
 */
export function noteServerTime(iso: string | undefined | null): void {
    if (!iso) return;
    const serverMs = Date.parse(iso);
    if (!Number.isFinite(serverMs)) return;
    offsetMs = serverMs - Date.now();
}

/** `Date.now()` corrected onto the server's clock. */
export function serverNow(): number {
    return Date.now() + offsetMs;
}

/** Test seam — resets the module-level offset between cases. */
export function resetServerClockOffset(): void {
    offsetMs = 0;
}
